export function FindFormIndex(nodes, id, parentPath = [])  {
    for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if (node.id === id) {
            return { indexPath: [...parentPath, i], node };
        }
        if (node.subForms && node.subForms.length > 0) {
            const found = FindFormIndex(node.subForms, id, [...parentPath, i, "subForms"]);
            if (found) return found;
        }
    }
    return null;
}

